module.exports = __webpack_public_path__ + "static/media/webull.252f808a.png";